import { render } from "./ImprintDialog.vue?vue&type=template&id=03a2132b"
import script from "./ImprintDialog.vue?vue&type=script&lang=js"
export * from "./ImprintDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__